import {  t  } from "@/client/libs/dummy-i18n";
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Sarah M.",
    role: "Software Engineer",
    quote: "Landed my dream job at a tech giant. The AI suggestions were spot-on and saved me hours of writing.",
    avatar: "SM",
  },
  {
    name: "David K.",
    role: "Product Manager",
    quote: "The templates are stunning. I got 3 interview calls in the first week of applying with my new resume.",
    avatar: "DK",
  },
  {
    name: "Emily R.",
    role: "Marketing Director",
    quote: "Privacy-first approach was exactly what I needed. No more worrying about my data being sold.",
    avatar: "ER",
  },
  {
    name: "Michael T.",
    role: "Data Scientist",
    quote: "Clean, modern, and incredibly easy to use. Best resume builder I've ever tried, hands down.",
    avatar: "MT",
  },
  {
    name: "Lisa P.",
    role: "UX Designer",
    quote: "The design customization options are endless. My resume truly stands out from the crowd now.",
    avatar: "LP",
  },
  {
    name: "James W.",
    role: "Sales Executive",
    quote: "Got my resume done in 15 minutes. The live preview made it so easy to see changes instantly.",
    avatar: "JW",
  },
];

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export const TestimonialsSection = () => {
  return (
    <section className="relative overflow-hidden bg-secondary/30 py-24">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 text-4xl font-bold tracking-tight lg:text-5xl">
            {t`Loved by professionals`}
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            {t`Join thousands who've transformed their career with StackMorph`}
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: index * 0.05, duration: 0.3 }}
              className="group relative overflow-hidden rounded-2xl border border-border/50 bg-background/50 p-8 backdrop-blur-xl transition-colors hover:border-primary/30 hover:shadow-xl opacity-0"
            >
              <div className="mb-6 flex items-center space-x-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-cyan-500 text-sm font-bold text-white">
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="font-semibold">{testimonial.name}</div>
                  <div className="text-sm text-muted-foreground">{testimonial.role}</div>
                </div>
              </div>
              
              <svg className="absolute right-4 top-4 h-8 w-8 text-primary/10" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>

              <p className="relative text-sm leading-relaxed text-muted-foreground">
                {testimonial.quote}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
